import fitty from 'fitty';

function initFitty(className, maxSize, minSize) {
    fitty(className, {
        maxSize: maxSize,
        minSize: minSize,
    });
}

const masthead = document.getElementById('masthead');
const landingPageContent = document.querySelector('.landing-page-content');
const headerGetStarted = document.getElementById('headerGetStarted');

function toggle(entries, o) {
    if(masthead) {
        masthead.classList.toggle('inViewport', entries[0].isIntersecting);
    }
}

function observeElem(element) {
    let observer = new IntersectionObserver(toggle);
    if(element && masthead) {
        observer.observe(element);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    // Function to get URL parameters
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Check for "program" URL parameter
    const programParam = getUrlParameter('program');
    const companyFieldWrap = document.querySelector('.company-field-wrap');

    if (programParam && companyFieldWrap) {
        companyFieldWrap.classList.remove('gfield_visibility_visible');
        companyFieldWrap.classList.add('gfield_visibility_hidden');
    }
    
    initFitty('.fitty-h1', 44, 38);
    initFitty('.fitty-h2', 34, 30);
    initFitty('.fitty-h3', 30, 24);
    initFitty('.fitty-h4', 24, 21);
    initFitty('.fitty-h5', 20, 18);
    initFitty('.fitty-h6', 18, 16);
    initFitty('.fitty-p', 16, 16);
    initFitty('.form-floating label', 16, 13); 

    observeElem(landingPageContent);

    if(headerGetStarted) {
        headerGetStarted.addEventListener('click', function(event) {
            masthead.classList.remove('inViewport');
            observeElem(landingPageContent);
        });
    }
});

